<template>
  <nav v-if="!showMetricsconstant">
    <div class="intro-text">
      <p v-for="(sentence, index) in sentences" :key="index" class="sentence"
        :style="{ animationDelay: `${index * 0.8}s` }">
        {{ sentence }}
      </p>
    </div>
    <ButtonTemplate :button-text="sessionstore.storytellingLoaded ? 'Continua' : 'Calcolo score in corso...'"
      @click="showMetrics" class="con-button" :disabled="!sessionstore.storytellingLoaded" />
  </nav>
  <nav v-if="showMetricsconstant">
    <StoryTellingResults />
  </nav>
</template>

<script>
// import { ref } from "vue";
// import LoadingBar from '@/components/widgets/LoadingBar.vue';
import StoryTellingResults from '@/components/screens/Posizionamento/StoryTellingMetrics.vue';
import ButtonTemplate from '@/components/widgets/button.vue';
import { useSessionStore } from '@/stores/sessionStore';

export default {
  setup() {
    const sessionstore = useSessionStore()
    return {
      sessionstore
    };
  },

  name: "StoryTellingConfirm",
  components: {
    // LoadingBar,
    ButtonTemplate,
    StoryTellingResults
  },
  data() {
    return {
      showMetricsconstant: false,
      sentences: [
        "Adesso che ti conosciamo meglio possiamo cominciare l'analisi del brand. Iniziamo con il secondo passo.",
        "Partiamo dallo storytelling studiando la tua comunicazione sui social media. In questa fase analizzeremo come e quanto la tua comunicazione è efficace.",
        "Misureremo la tua capacità di costruire un discorso organizzato attorno al brand.",
        "Il risultato va da un massimo di 100 (complimenti, la tua comunicazione è molto efficace!) al minimo di 0 (ci sono molti margini di miglioramento ;))"
      ]
    };
  },
  methods: {
    showMetrics() {
      this.showMetricsconstant = true;
      this.$emit('advance-step');
    },
  }
};

</script>


<style lang="scss" scoped>
nav {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  padding: 4rem;
}

.intro-text {
  width: 100%;
  max-width: 1200px;
  text-align: left;
  margin-bottom: 3rem;
}

.loading-bar {
  justify-content: center;
  display: flex;
  width: 50%;
}

.con-button {
  margin-top: 3rem;
  --button-border-color: #2e4eed;
  --button-text-color: #ffffff;
  --button-background-color: #2e4eed;
  --button-background-hover-color: #1e3ed8;
  --button-border-radius: 0;
  width: 100%;
  max-width: 1200px;
  font-size: 1.5rem;
  padding: 1.5rem;
  opacity: 1;
  transition: opacity 0.3s ease;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.sentence {
  font-size: 2.5rem;
  line-height: 1.4;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2rem;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s ease forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>